import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state() {
    return {
      dataTransferObject: null
    }
  },
  getters,
  actions,
  mutations
}
